<template>
  <div class="swiper-view">
    <div class="swiper-header" v-if="swiperData.text">
      <div class="sort">
        <span>{{ swiperData.index }}</span>
      </div>
      <p>
        {{ swiperData.text }}
      </p>
    </div>
    <div class="swiper-img">
      <img v-if="swiperData.img" :src="swiperData.img" alt="" />
    </div>
    <div class="arrow-wrap">
      <div class="arrow" @click="onArrow(true)">
        <img class="left" src="../../assets/images/home/arrow.png" alt=""/>
      </div>
      <div class="arrow arrow-right" @click="onArrow(false)">
        <img class="right" src="../../assets/images/home/arrow.png" alt=""/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    swiperData: {
      type: Object,
    },
  },
  methods: {
    onArrow(flag) {
      if (flag) {
        console.log('left');
        this.$emit('onSwitch', this.swiperData.index - 1);
      } else {
        console.log('right');
        this.$emit('onSwitch', this.swiperData.index + 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-view {
}
@media screen and (max-width: 767px) {
  .swiper-view {
    .swiper-header {
      margin-top: 0.8rem;
      display: flex;
      align-items: center;
      .sort {
        width: 0.48rem;
        height: 0.48rem;
        border: 0.03rem solid #2980fe;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          font-size: 0.28rem;
          color: #2980fe;
        }
      }
      p {
        margin-left: 0.32rem;
        flex: 1;
        font-size: 0.24rem;
        font-family: PingFang SC, PingFang SC-600;
        color: #2980fe;
      }
    }
    .swiper-img {
      margin-top: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        height: 5rem;
        object-fit: contain;
      }
    }
    .arrow-wrap {
      margin-top: 1.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      :nth-child(2) {
        margin-left: 0.64rem;
      }
      .arrow {
        position: relative;
        width: 0.64rem;
        height: 0.64rem;
        background: #f5f6f7;
        border: 0.01rem solid #e6e8ea;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 0.3rem;
          height: 0.3rem;
        }
        .left {
          transform: rotate(90deg);
        }
        .right {
          transform: rotate(-90deg);
        }
      }
    }
  }
}
</style>
